// Runtime kill-switch for obstacle-avoiding edge routing (#918). Lets support/ops or a dev
// fall back to plain (non-routed) edges without a code change if routing ever misbehaves.
// Precedence: URL `?edgeRouting=off|on`, then localStorage `edgeRouting`, else enabled.
export const isEdgeRoutingEnabled = (): boolean => {
  try {
    const param = new URLSearchParams(window.location.search).get('edgeRouting');
    if (param === 'off') return false;
    if (param === 'on') return true;
    const stored = window.localStorage.getItem('edgeRouting');
    if (stored === 'off') return false;
    if (stored === 'on') return true;
  } catch {
    // No window/localStorage (e.g. tests) — fall through to the default.
  }
  return true;
};
